<template>
    <el-dialog ref="modal-comprehensive-business" title="PR申请" z-index="1030"
               @reset="handlePrApplyClose" @close="handlePrApplyClose" append-to-body
               :visible.sync=prApplyDialogVisible width="80%" :close-on-click-modal=false hide-footer>
        <el-form @submit="handlePrApplySubmit" @reset="handlePrApplyClose" ref="form"
                 label-position="top">
            <div class="d-flex flex-row">
                <el-select value="" v-model="purchasingType" placeholder="请选择采购&物品类别" filterable>
                    <el-option v-for="(item,idx) in typeOptions" :key="idx" :value="item"
                               :label="item.label">
                        {{ item.label }}
                    </el-option>
                </el-select>
                <el-input-number class="ml-1" v-model="prApplySaveForm.budget" :min="0" :controls=false
                                 placeholder="请输入预算"></el-input-number>
                <el-input class="ml-1" v-model="prApplySaveForm.remark"
                          placeholder="请填写需求描述"></el-input>
            </div>
            <div v-if="purchasingType  && purchasingType.label">
                <el-upload
                        drag
                        action="#"
                        class="el-upload"
                        :on-change="handleFileUpload"
                        :file-list="fileList"
                        :show-file-list="false"
                        :auto-upload="false">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__tip" slot="tip">只能上传xlsx文件</div>
                </el-upload>
                <el-progress
                        v-if="showProgress"
                        :percentage="progress"
                        color="rgb(78, 144, 254)"
                        text-inside>
                </el-progress>
            </div>
            <el-button v-if="purchasingType  && purchasingType.label" style=" margin-top: 20px "
                       @click="handleRowAction('','add')">新增
            </el-button>
            <el-row v-if="purchasingType  && purchasingType.label && purchasingType.label.indexOf('间接采购') !== -1">
                <div class="d-flex flex-row">
                    <el-col>
                        <el-form-item>
                            <el-select
                                    v-model="prApplySaveForm.indirectPurchaseDetail.department" filterable
                                    placeholder="请选择使用部门" size="mini">
                                <el-option
                                        v-for="item in departmentOptions"
                                        :key="item.value"
                                        :value="item.value"
                                        :label="item.label">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item>
                            <el-input
                                    v-model="prApplySaveForm.indirectPurchaseDetail.projectNo"
                                    placeholder="项目号" size=mini></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item>
                            <el-input
                                    v-model="prApplySaveForm.indirectPurchaseDetail.wbsNo"
                                    placeholder="WBS" size=mini></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item>
                            <el-select
                                    v-model="prApplySaveForm.costCenter"
                                    placeholder="成本中心(不选择默认走部门经理)" filterable size="mini">
                                <el-option
                                        v-for="item in costCenterOptions"
                                        :key="item.value"
                                        :value="item.value"
                                        :label="item.label">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item>
                            <el-input
                                    v-model="prApplySaveForm.indirectPurchaseDetail.glAccountNo"
                                    placeholder="GL Account" size=mini></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item>
                            <el-input
                                    v-model="prApplySaveForm.indirectPurchaseDetail.fixedAssetNo"
                                    placeholder="固资号/再建工程" size=mini></el-input>
                        </el-form-item>
                    </el-col>
                </div>
            </el-row>
            <el-table
                    :data="prApplySaveForm.indirectPurchaseDetail.indirectPurchaseDetailList"
                    style="width: 100%"
                    class="text-center"
                    v-if="purchasingType  && purchasingType.label && purchasingType.label.indexOf('间接采购') !== -1">
                <el-table-column class="w-80"
                                 v-for="(column, index) in indirectPurchaseDetailTableColumns"
                                 :key="index"
                                 :prop="column.prop"
                                 :label="column.label">
                    <template slot-scope="scope">
                        <el-input
                                v-if="column.type === 'text'"
                                v-model="scope.row[column.prop]"
                                :disabled="!scope.row.editable"
                                size="mini">
                        </el-input>
                        <el-input-number
                                v-else-if="column.type === 'number'"
                                v-model="scope.row[column.prop]"
                                :disabled="!scope.row.editable"
                                :controls="false"
                                size="mini">
                        </el-input-number>
                        <el-date-picker
                                v-else-if="column.type === 'date'"
                                v-model="scope.row[column.prop]"
                                :disabled="!scope.row.editable"
                                type="date"
                                placeholder="选择日期"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                size="mini">
                        </el-date-picker>
                        <el-select
                                v-else-if="column.type === 'select'"
                                v-model="scope.row[column.prop]"
                                :disabled="!scope.row.editable"
                                filterable
                                placeholder="请选择"
                                size="mini">
                            <el-option
                                    v-for="item of column.options || userOptions"
                                    :key="item.value"
                                    :value="item.value"
                                    :label="item.label">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column
                        label="操作">
                    <template slot-scope="scope">
                        <div class="btn-group">
                            <el-button-group>
                                <el-button @click="handleRowAction(scope.$index,'edit')" v-if="!scope.row.editable"
                                           size=mini>
                                    编辑
                                </el-button>
                                <el-button type="primary" @click="handleRowAction(scope.$index,'save')"
                                           v-if="scope.row.editable" size=mini>保存
                                </el-button>
                                <el-button type="danger" icon="el-icon-delete"
                                           @click="handleRowAction(scope.$index,'remove')"
                                           size=mini>删除
                                </el-button>
                            </el-button-group>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-table
                    :data="prApplySaveForm.shippingDetailList"
                    style="width: 100%"
                    :header-align="'center'"
                    v-if="purchasingType  && purchasingType.label && purchasingType.label.indexOf('直接采购') !== -1">
                >明细
                <el-table-column
                        class="w-20,-flip-vertical"
                        v-for="(column, index) in shippingDetailLisTableColumns"
                        :key="index"
                        :prop="column.prop"
                        :label="column.label"
                >
                    <template slot-scope="scope">
                        <el-input
                                v-if="column.type === 'text'"
                                v-model="scope.row[column.prop]"
                                :disabled="!scope.row.editable"
                                size="mini">
                        </el-input>
                        <el-input-number
                                v-else-if="column.type === 'number'"
                                v-model="scope.row[column.prop]"
                                :disabled="!scope.row.editable"
                                :controls="false"
                                size="mini">
                        </el-input-number>
                        <el-date-picker
                                v-else-if="column.type === 'date'"
                                v-model="scope.row[column.prop]"
                                :disabled="!scope.row.editable"
                                type="date"
                                placeholder="选择日期"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                size="mini">
                        </el-date-picker>
                        <el-select
                                filterable
                                v-else-if="column.type === 'select'"
                                v-model="scope.row[column.prop]"
                                :disabled="!scope.row.editable"
                                placeholder="请选择"
                                size="mini">
                            <el-option
                                    v-for="item of column.options || userOptions"
                                    :key="item.value"
                                    :value="item.value"
                                    :label="item.label">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column
                        label="操作">
                    <template slot-scope="scope">
                        <div class="btn-group">
                            <el-button-group>
                                <el-button @click="handleRowAction(scope.$index,'edit')" v-if="!scope.row.editable"
                                           size=mini>
                                    编辑
                                </el-button>
                                <el-button type="primary" @click="handleRowAction(scope.$index,'save')"
                                           v-if="scope.row.editable" size=mini>保存
                                </el-button>
                                <el-button type="danger" icon="el-icon-delete"
                                           @click="handleRowAction(scope.$index,'remove')"
                                           size=mini>删除
                                </el-button>
                            </el-button-group>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handlePrApplyClose" id="cancel">取 消</el-button>
            <el-tooltip class="item" effect="dark" content="请至少选择一种类别" placement="top">
                <span>
                    <el-button type="primary" @click="handlePrApplySubmit" id="submit">确 定
                    </el-button>
                </span>
            </el-tooltip>
        </div>
    </el-dialog>
</template>
<script>
import emCommonListMixin from "@/mixin/em/common/list";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import emApiMixin from "@/mixin/em/common/api";
import * as XLSX from "xlsx";
import de from "element-ui/src/locale/lang/de";

export default {
    computed: {
        de() {
            return de
        }
    },
    mixins: [emCommonListMixin, emCommonGotoMixin, emApiMixin],
    name: "prApplyForm",
    data() {
        return {
            tableData: [],
            fileList: [],
            showProgress: false,
            progress: 0,
            typeOptions: [],
            userOptions: [],
            departmentOptions: [],
            costCenterOptions: [],
            purchasingType: {},
            prApplySaveForm: {
                type: '',
                indirectPurchaseDetail: {
                    indirectPurchaseDetailList: []
                },
                shippingDetailList: [],
                remark: ''
            },
            indirectPurchaseDetailTableColumns: [
                {prop: 'name', label: '物品名称', type: 'text'},
                {prop: 'specification', label: '规格', type: 'text'},
                {prop: 'quantity', label: '数量', type: 'number'},
                {prop: 'unit', label: '单位', type: 'text'},
                {prop: 'expectDeliveryDate', label: '期望到货日期(YYYY-MM-DD)', type: 'date'},
                {prop: 'buyer', label: '采购员', type: 'select'},

                {
                    prop: 'newToolFlag',
                    label: '是否新工具',
                    type: 'select',
                    options: [{value: true, label: '是'}, {value: false, label: '否'}]
                },
                {prop: 'buyReason', label: '购买原因', type: 'text'},
                {
                    prop: 'oldToolFlag',
                    label: '是否旧工具',
                    type: 'select',
                    options: [{value: true, label: '是'}, {value: false, label: '否'}]
                },
                {prop: 'oldToolDestination', label: '旧工具去向', type: 'text'},
                {prop: 'remark', label: '备注', type: 'text'}
            ],
            shippingDetailLisTableColumns: [
                {prop: 'projectNo', label: '项目号', type: 'text'},
                {prop: 'wbsNo', label: 'WBS号', type: 'text'},
                {prop: 'glAccountNo', label: 'GL Account', type: 'text'},
                {prop: 'materialNo', label: '物料号', type: 'text'},
                {prop: 'materialDesc', label: '物料描述', type: 'text'},
                {prop: 'quantity', label: '数量', type: 'number'},
                {prop: 'deliveryData', label: '交货期(YYYY-MM-DD)', type: 'date'},
                {prop: 'consigneeAddress', label: '收货地点', type: 'text'},
                {prop: 'buyer', label: '采购员', type: 'select'},
                {prop: 'remark', label: '备注', type: 'text'}
            ],
        }
    },
    props: {
        prApplyDialogVisible: {
            type: Boolean,
            default: false
        },
    },
    methods: {
        handlePrApplyClose() {
            this.$emit("change");
            this.$refs["form"].resetFields();
            this.prApplySaveForm = {
                type: '',
                budget: undefined,
                indirectPurchaseDetail: {
                    indirectPurchaseDetailList: []
                },
                shippingDetailList: []
            };
        },
        handlePrApplySubmit() {
            let bzUrl = `${this.$_emApiMixin_entityBaseApi("sithMesStoolPrApplicationRecord")}/generatePrApplicationRecord`
            if (this.prApplySaveForm.indirectPurchaseDetail) {
                let detail = this.prApplySaveForm.indirectPurchaseDetail;
                detail.indirectPurchaseDetailList.forEach(o => {
                    o.department = detail.department;
                    o.projectNo = detail.projectNo;
                    o.wbsNo = detail.wbsNo;
                    o.glAccountNo = detail.glAccountNo;
                    o.fixedAssetNo = detail.fixedAssetNo;
                });
                this.prApplySaveForm.indirectPurchaseDetail = detail.indirectPurchaseDetailList;
            }

            this.prApplySaveForm.type = this.purchasingType.value;
            this.$message.success("PR申请中");
            this.$_emApiMixin_post(bzUrl, this.prApplySaveForm).then(response => {
                if (response.status === 200) {
                    this.$message.success("PR申请成功,请到待办页面查看");
                    this.handlePrApplyClose();
                    this.$emit("doQuery")
                } else {
                    this.$message.error(response.message);
                }
            })
        },
        handleRowAction(index, actionType) {
            if (actionType === 'add') {
                if (this.purchasingType.label.indexOf('间接采购') !== -1) {
                    this.prApplySaveForm.indirectPurchaseDetail.indirectPurchaseDetailList.push({editable: true});
                } else {
                    this.prApplySaveForm.shippingDetailList.push({editable: true});
                }
            } else if (actionType === 'edit') {
                if (this.purchasingType.label.indexOf('间接采购') !== -1) {
                    this.prApplySaveForm.indirectPurchaseDetail.indirectPurchaseDetailList[index].editable = true;
                } else {
                    this.prApplySaveForm.shippingDetailList[index].editable = true;

                }
            } else if (actionType === 'save') {
                if (this.purchasingType.label.indexOf('间接采购') !== -1) {

                    this.prApplySaveForm.indirectPurchaseDetail.indirectPurchaseDetailList[index].editable = false;
                } else {
                    this.prApplySaveForm.shippingDetailList[index].editable = false;
                }
            } else if (actionType === 'remove') {
                if (this.purchasingType.label.indexOf('间接采购') !== -1) {
                    this.prApplySaveForm.indirectPurchaseDetail.indirectPurchaseDetailList.splice(index, 1);
                } else {
                    this.prApplySaveForm.shippingDetailList.splice(index, 1);
                }
            }
        },
        handleFileUpload(file) {
            if (!this.purchasingType) {
                this.$message.error("请选择采购类型再上传文件")
                return;
            }
            this.showProgress = true;
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, {type: 'array'});
                const firstSheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[firstSheetName];
                const parsedData = XLSX.utils.sheet_to_json(worksheet, {header: 1});
                // Match column headers with English fields
                const headers = parsedData[0];
                const tableColumns = this.getTableColumns();
                const columnMappingResult = this.matchColumnHeaders(headers, tableColumns);

                if (!columnMappingResult) {
                    this.$message.warning('表头与字段匹配失败，请检查文件格式');
                    return;
                }
                // Convert data to object array
                this.tableData = parsedData.slice(1).map(row => {
                    let rowData = {};
                    headers.forEach((header, index) => {
                        const prop = columnMappingResult[header];
                        if (header === "期望到货日期(YYYY-MM-DD)" && Number.isInteger(row[index])) {
                            // 调用自定义函数将 Excel 日期转换为 JavaScript 日期对象
                            rowData['expectDeliveryDate'] = formatDate(excelNumberToDate(row[index]));
                            return;
                        } else if (header === "交货期(YYYY-MM-DD)" && Number.isInteger(row[index])) {
                            rowData['deliveryData'] = formatDate(excelNumberToDate(row[index]));
                            return;
                        }

                        function formatDate(date) {
                            const year = date.getFullYear();
                            const month = String(date.getMonth() + 1).padStart(2, '0');
                            const day = String(date.getDate()).padStart(2, '0');
                            const hours = String(date.getHours()).padStart(2, '0');
                            const minutes = String(date.getMinutes()).padStart(2, '0');
                            const seconds = String(date.getSeconds()).padStart(2, '0');
                            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
                        }

                        // 自定义函数将 Excel 数字日期转换为 JavaScript 日期对象
                        function excelNumberToDate(excelDate) {
                            const utcDays = excelDate - 25569; // Excel 中的日期从 1900 年 1 月 1 日开始，而 JavaScript 中的日期从 1970 年 1 月 1 日开始，因此需要进行调整
                            const utcValue = utcDays * 86400; // 一天的秒数
                            const utcTime = utcValue * 1000; // 转换为毫秒数
                            return new Date(utcTime);
                        }

                        if (prop) {
                            rowData[prop] = row[index];
                            rowData.editable = false;
                        }
                    });
                    return rowData;
                });

                if (this.tableData.length === 0) {
                    this.$message.error('上传文件为空');
                } else if (this.purchasingType.label.indexOf('间接采购') !== -1) {
                    this.prApplySaveForm.indirectPurchaseDetail.indirectPurchaseDetailList = this.tableData;
                } else if (this.purchasingType.label.indexOf('直接采购') !== -1) {
                    this.prApplySaveForm.shippingDetailList = this.tableData;
                }

                // Simulate delay for demonstration purpose
                let interval = setInterval(() => {
                    this.progress += 10;
                    if (this.progress >= 100) {
                        clearInterval(interval);
                        this.progress = 0;
                        this.showProgress = false;
                    }
                }, 500);

            };
            reader.readAsArrayBuffer(file.raw);
        },
        matchColumnHeaders(headers, tableColumns) {
            // Match column headers with English fields
            let result = {};
            for (let header of headers) {
                for (let column of tableColumns) {
                    if (column.label === header) {
                        result[header] = column.prop;
                        break;
                    }
                }
            }
            return result;
        },
        getTableColumns() {
            // Determine which table columns to use based on your logic
            // For example, you can use this.indirectPurchaseDetailTableColumns or this.shippingDetailLisTableColumns
            if (this.purchasingType.label.indexOf('库存') !== -1 || this.purchasingType.label.indexOf('间接采购') !== -1) {
                return this.indirectPurchaseDetailTableColumns;
            } else if (this.purchasingType.label.indexOf('直接采购') !== -1) {
                return this.shippingDetailLisTableColumns;
            } else {
                this.$message.warning("不支持的采购类型，请配置直接采购或间接采购的采购类型");
                return [];
            }
        },
        beforeUpload(file) {
            // 校验文件类型和大小
            const isExcel = /\.(xlsx|xls)$/.test(file.name);
            if (!isExcel) {
                this.$message.error('只能上传 Excel 文件');
                return false;
            }
            return true;
        }
    },
    watch: {
        prApplyDialogVisible(val) {
            if (val && this.typeOptions.length === 0) {
                let operationUrl = `${this.$_emApiMixin_entityBaseApi("sithMesStoolPrApplicationTypeConfig")}/findByFilter`
                this.$_emApiMixin_post(operationUrl, {}).then(response => {
                    if (response.status === 200) {
                        for (let option of response.data.list) {
                            this.typeOptions.push({
                                value: option['id'],
                                label: option['purchasingType'] + "-" + option['itemType'],
                            });
                        }
                    }
                })
            }
            if (val && this.userOptions.length === 0) {
                let url = `${this.$_emApiMixin_entityBaseApi("emAclUser")}/findByFilter`
                this.$_emApiMixin_post(url, {
                    statusFilter: "1",
                    deptIdFilter: 873392
                }).then(response => {
                            for (let row of response.data.list) {
                                this.userOptions.push({
                                    value: row['loginName'] + '|' + row['name'],
                                    label: row['name'] + '-' + row['loginName']
                                });
                            }
                        }
                )
            }
            if (val && this.departmentOptions.length === 0) {
                let uri = `${this.$_emApiMixin_entityBaseApi('emDictData')}/findByFilter`;
                this.$_emApiMixin_post(uri, {
                    dictTypeFilter: 'pr_apply_department'
                }).then((response) => {
                    response.data.list.forEach((item) => {
                        this.departmentOptions.push({
                            value: item['dictValue'],
                            label: item['dictValue'] + '-' + item['dictLabel']
                        });
                    });
                });
            }
            if (val && this.costCenterOptions.length === 0) {
                let uri = `${this.$_emApiMixin_entityBaseApi('emDictData')}/findByFilter`;
                this.$_emApiMixin_post(uri, {
                    dictTypeFilter: 'cost_center_manager'
                }).then((response) => {
                    response.data.list.forEach((item) => {
                        this.costCenterOptions.push({
                            value: item['dictValue'],
                            label: item['dictValue'] + '-' + item['dictLabel']
                        });
                    });
                });
            }
        }
    },

    mounted() {
    }
}
</script>

<style scoped>
.el-form-item__content .el-input-number--mini {
    width: 100% !important;
    flex-wrap: wrap;
}

.el-form-item__content .el-select--mini {
    width: 100% !important;
    flex-wrap: wrap;
}

.el-form-item {
    margin-left: 1rem;
}

.el-customer-select {
    width: 30rem;
}

::v-deep .popper-class {
    max-width: 30rem;
}

.iclass-text-ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.btn-group {
    display: flex;
    align-items: center;
}

.btn-group > .el-button {
    margin-right: 2rem; /* 调整按钮之间的间距 */
}

.el-table thead th, .el-table tbody td {
    text-align: center;
}

.el-input-number--mini .el-input__inner {
    width: 80%;
}

.el-upload {
    width: 30% !important;
}
</style>
